import React from "react";
import { Grid, IconButton, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add"; // Заменили на обычный плюс
import FilterListIcon from "@material-ui/icons/FilterList";
import RefreshIcon from "@material-ui/icons/Refresh";
import { OperationType, hasPermission } from "../../auth/authRoles";
import useAuth from "../../hooks/useAuth";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "4px",
  },
  additionalButtons: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    alignItems: "center"
  },
  // Стиль для маленьких квадратных кнопок
  tinySquareButton: {
    minWidth: "36px !important", // Перебиваем стандартный minWidth
    width: "32px",
    height: "36px",
    padding: "6px", // Минимальный отступ
    borderRadius: "4px", // Скругление углов как на фото
  }
}));

const TopButtons = (props) => {
  const {
    updateClick,
    addClick,
    filterClick,
    text,
    hideAddButton,
    variant,
    winPermissionName,
    additionalButtons,
    customButtons
  } = props;
  const classes = useStyles();

  const { user } = useAuth();

  const permissionName = winPermissionName || text;

  const renderExtraButtons = () => {
    const buttons = [];

    if (additionalButtons) {
      buttons.push(additionalButtons);
    }

    if (customButtons) {
      if (Array.isArray(customButtons)) {
        buttons.push(...customButtons);
      } else {
        buttons.push(customButtons);
      }
    }

    if (buttons.length === 0) return null;

    return (
      <Grid item className={classes.additionalButtons}>
        {buttons}
      </Grid>
    );
  };

  return (
    <Grid container spacing={0} alignItems="center" className="flex justify-end" style={{ gap: '8px' }}>

      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={updateClick}
          title="Обновить"
          disabled={props.disabledAdd}
          className={classes.tinySquareButton}
        >
          <RefreshIcon style={{ color: 'white', fontSize: 20 }} />
        </Button>
      </Grid>

      {addClick && hasPermission(permissionName, OperationType.CREATE, user) && (
        <Grid item className={hideAddButton === undefined ? null : "hidden"}>
          <Button
            variant="contained"
            color="primary"
            onClick={addClick}
            title="Новая запись"
            disabled={props.disabledAdd}
            className={classes.tinySquareButton}
          >
            <AddIcon style={{ color: 'white', fontSize: 20 }} />
          </Button>
        </Grid>
      )}

      {/* Кнопка Фильтр */}
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={filterClick}
          title="Фильтрация"
          className={classes.tinySquareButton}
        >
          <FilterListIcon style={{ color: 'white', fontSize: 20 }} />
        </Button>
      </Grid>

      {renderExtraButtons()}
    </Grid>
  );
};

export default React.memo(TopButtons);